import { z } from 'zod'
import { useParsedStorage } from '../../../core'

export const GlobalChatLayoutSchema = z.enum(['dialog', 'sidebar'])
export type GlobalChatLayout = z.infer<typeof GlobalChatLayoutSchema>

const GLOBAL_CHAT_LAYOUT_STORAGE_KEY = 'global-agent-chat-layout'

export function useGlobalChatLayout() {
  return useParsedStorage(GLOBAL_CHAT_LAYOUT_STORAGE_KEY, {
    initialValue: 'dialog',
    schema: GlobalChatLayoutSchema,
    strategy: 'local',
  })
}
